import { AppDispatchNext } from 'actions/actions.typesNext'
import { ApiResult } from 'api/fetchApi'
import { photoLikeApi } from 'api/rating/likePhotoApi'

import { handleRatingErrorAction } from './photoRatingAction'

export type VoteSource = 1 | 2

export const LIKE_PHOTO_NEXT = 'LIKE_PHOTO_NEXT' as const

export const likePhotoNextAction =
  (photoId: number, voteSource: VoteSource) =>
  async (dispatch: AppDispatchNext) => {
    const { error } = (await dispatch(
      likePhotoNextPlainAction(photoId, voteSource)
    )) as unknown as ApiResult

    if (error?.code) {
      dispatch(handleRatingErrorAction(error))
    }

    return Promise.resolve()
  }

export const likePhotoNextPlainAction = (
  photoId: number,
  voteSource: VoteSource
) => ({
  type: LIKE_PHOTO_NEXT,
  promise: () => photoLikeApi(photoId, voteSource),
})

export const LIKE_PHOTO_PROFILE_NEXT = 'LIKE_PHOTO_PROFILE_NEXT' as const

export const likePhotoNextProfilePlainAction = (photoId: number) => ({
  type: LIKE_PHOTO_PROFILE_NEXT,
  promise: () => photoLikeApi(photoId, 2),
})
